export function PageHeader({ title, subtitle, actions }) {
  return (
    <header className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div>
        <h1 className="font-serif text-3xl md:text-4xl font-extrabold tracking-tight leading-none">
          {title}
        </h1>
        {subtitle && <p className="mt-2.5 text-sm text-slate-500 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-3 shrink-0">{actions}</div>}
    </header>
  );
}
